import { render } from "./News2526FW.vue?vue&type=template&id=bdd97c2e&scoped=true"
import script from "./News2526FW.vue?vue&type=script&lang=js"
export * from "./News2526FW.vue?vue&type=script&lang=js"

import "./News2526FW.vue?vue&type=style&index=0&id=bdd97c2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd97c2e"]])

export default __exports__